module.exports = __webpack_public_path__ + "static/media/complexImg.4fcba13c.png";